import { LocaleContext as e } from "./context.js";
import { i18n as t } from "./instance.js";
import { useContext as n } from "react";
import { defaultNS as r, getUseLocoTranslation as i } from "@systemeio/util";
import { useTranslation as a } from "react-i18next";
//#region src/i18n/hooks.ts
var o = [r], s = i({
	useTranslation: (r, i) => {
		let { i18n: o } = n(e) ?? {};
		return a(r, {
			i18n: o ?? t,
			...i
		});
	},
	defaultNamespaces: o,
	namespaceMapper: () => o
});
//#endregion
export { s as useTranslation };
